import { render, staticRenderFns } from "./Topbar.vue?vue&type=template&id=afb52a82&scoped=true&"
import script from "./Topbar.vue?vue&type=script&lang=ts&"
export * from "./Topbar.vue?vue&type=script&lang=ts&"
import style0 from "./Topbar.vue?vue&type=style&index=0&id=afb52a82&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb52a82",
  null
  
)

export default component.exports